import { Component, OnInit } from '@angular/core';
import { EmpleadomastServicio } from '../../../seguridad/seguridad/empleadomast.service';
import { CoDocumentoServicio } from '../../../erp/comercial/codocumento/service/codocumento.service';
import { CoVendedorServicio } from '../../../erp/comercial/covendedor/servicio/covendedor.service';
import { FiltroCoDocumentoCobrar } from '../../../erp/comercial/codocumento/dominio/FiltroCoDocumentoCobrar';
import { Router } from '../../../../../node_modules/@angular/router';
import { DtoPersonamast } from '../../../erp/core/personamast/dominio/DtoPersonamast';
import { NGXLogger } from 'ngx-logger';
import { PrincipalBaseComponent } from '../../../util/PrincipalBaseComponent';
import { MessageService } from 'primeng/api';
import { NoAuthorizationInterceptor } from '../../../util/interceptor/NoAuthorizationInterceptor';
import { DtoCoDocumentoCobrar } from '../../../erp/comercial/codocumento/dominio/DtoCoDocumentoCobrar';

@Component({
    templateUrl: './dashboard.component.html'
})
export class DashboardDemoComponent extends PrincipalBaseComponent implements OnInit {

    constructor(
        private router: Router,
        private empleadomastServicio: EmpleadomastServicio,
        private coDocumentoServicio: CoDocumentoServicio,
        private coVendedorServicio: CoVendedorServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        logger: NGXLogger
    ) {
        super(noAuthorizationInterceptor, messageService, logger);
    }
    cantidadDocumentosVencidos: number;
    cantidadDocumentosPorVencer: number;

    cantidadLetrasAceptadasMes: number;
    cantidadLetrasPorAceptadasMes: number;
    cantidadLetrasPorAceptadasMesAnterior: number;
    filtro: FiltroCoDocumentoCobrar = new FiltroCoDocumentoCobrar();
    avanceVentas: DtoCoDocumentoCobrar = new DtoCoDocumentoCobrar();

    filtroCliente: DtoPersonamast = new DtoPersonamast();
    irArutaDocVencidos(ruta) {
        this.filtroCliente.conVencidos = true;

        this.router.navigate(['/royal/codocumentocobrar-listado', 'VERDESDEDASHBOAR', JSON.stringify(this.filtroCliente)], { skipLocationChange: true });
    }

    irArutaDocNoVencidos(ruta) {
        this.filtroCliente.conVencidos = false;
        this.router.navigate(['/royal/codocumentocobrar-listado', 'VERDESDEDASHBOAR', JSON.stringify(this.filtroCliente)], { skipLocationChange: true });
    }

    irArutaLetraAceptadasMes(ruta) {
        this.filtroCliente.accion = 'VERDESDEDASHBOAR';
        this.filtroCliente.conAceptada = 'S';
        var date = new Date();
        this.filtroCliente.desde = new Date(date.getFullYear(), date.getMonth(), 1);
        this.filtroCliente.hasta = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.router.navigate(['/royal/letra-listado', JSON.stringify(this.filtroCliente)], { skipLocationChange: true });
    }

    irArutaLetraNoAceptadasMes(ruta) {
        this.filtroCliente.accion = 'VERDESDEDASHBOAR';
        this.filtroCliente.conAceptada = 'N';
        var date = new Date();
        this.filtroCliente.desde = new Date(date.getFullYear(), date.getMonth(), 1);
        this.filtroCliente.hasta = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.router.navigate(['/royal/letra-listado', JSON.stringify(this.filtroCliente)], { skipLocationChange: true });
    }


    ngOnInit() {
        this.empleadomastServicio.obtenerUsuarioActual().then(
            em => {
                this.coVendedorServicio.obtenerPorId().then(
                    vendedor => {
                        this.filtro.usuarioActualCompania = em.companiaSocioCodigo;
                        this.filtro.idVendedor = vendedor.pk.vendedor
                        this.filtroCliente.vendedor = vendedor.pk.vendedor;
                        this.coDocumentoServicio.cantidadDocumtosVencidos(this.filtro).then(
                            resp => {
                                this.cantidadDocumentosVencidos = resp.cantidadDocumentos;
                            }
                        );

                        this.coDocumentoServicio.cantidadDocumtosPorVencer(this.filtro).then(
                            resp => {
                                this.cantidadDocumentosPorVencer = resp.cantidadDocumentos;
                            }
                        )

                        //ACEPTADAS
                        this.filtro = new FiltroCoDocumentoCobrar();
                        this.filtro.usuarioActualCompania = em.companiaSocioCodigo;
                        this.filtro.idVendedor = vendedor.pk.vendedor;
                        this.filtro.conAceptada = 'S';
                        var date = new Date();
                        this.filtro.desde = new Date(date.getFullYear(), date.getMonth(), 1);
                        this.filtro.hasta = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                        this.coDocumentoServicio.cantidadLetrasAPeticion(this.filtro).then(
                            resp => {
                                if (resp.totalMontoLetras == null) {
                                    this.cantidadLetrasAceptadasMes = 0;
                                } else {
                                    this.cantidadLetrasAceptadasMes = resp.totalMontoLetras;
                                }

                            }
                        )


                        //NO ACEPTADAS
                        this.filtro = new FiltroCoDocumentoCobrar();
                        this.filtro.usuarioActualCompania = em.companiaSocioCodigo;
                        this.filtro.idVendedor = vendedor.pk.vendedor;
                        this.filtro.conAceptada = 'N';
                        var date = new Date();
                        this.filtro.desde = new Date(date.getFullYear(), date.getMonth(), 1);
                        this.filtro.hasta = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                        this.coDocumentoServicio.cantidadLetrasAPeticion(this.filtro).then(
                            resp => {
                                if (resp.totalMontoLetras == null) {
                                    this.cantidadLetrasPorAceptadasMes = 0;
                                } else {
                                    this.cantidadLetrasPorAceptadasMes = resp.totalMontoLetras;
                                }

                            }
                        )

                        //NO ACEPTADAS MES ANTERIORES
                        this.filtro = new FiltroCoDocumentoCobrar();
                        this.filtro.usuarioActualCompania = em.companiaSocioCodigo;
                        this.filtro.idVendedor = vendedor.pk.vendedor;
                        this.filtro.conAceptada = 'N';
                        var date = new Date();
                        this.filtro.desde = new Date(date.getFullYear(), date.getMonth(), -1);
                        this.filtro.hasta = new Date(1900, date.getMonth() + 1, 0);
                        this.coDocumentoServicio.cantidadLetrasAPeticion(this.filtro).then(
                            resp => {
                                if (resp.totalMontoLetras == null) {
                                    this.cantidadLetrasPorAceptadasMesAnterior = 0
                                } else {
                                    this.cantidadLetrasPorAceptadasMesAnterior = resp.totalMontoLetras;
                                }
                            }
                        )


                        //AVANCE DE VENTAS
                        this.filtro = new FiltroCoDocumentoCobrar();
                        this.filtro.idVendedor = vendedor.pk.vendedor;
                        this.filtro.desde = new Date();
                        this.coDocumentoServicio.obtenerAvanceVentas(this.filtro).then(
                            resp => {
                                if(resp!=null){
                                    this.avanceVentas = resp;
                                }else{
                                    this.avanceVentas.montoAvance=0.00;
                                    this.avanceVentas.metaMonto=0.00;
                                }
                            }
                        )



                    }
                )
            }
        );
    }
}


